import {ProtocolFindProductionLogsDataWrapper} from '../wrappers/protocolFindProductionLogsDataWrapper';

export class ProtocolFindProductionLogsSummaryViewModel {
    public static readonly SUMMARY_MESSAGE_LENGTH = 40;

    position: number;
    products: string;
    applications: string;
    timestampTimeRange: string;
    message: string;
    userCodes: string;
    emails: string;
    deviceModels: string;
    productVersions: string;
    applicationVersions: string;
    hits: number;

    public static from(dataWrapper: ProtocolFindProductionLogsDataWrapper[]): ProtocolFindProductionLogsSummaryViewModel[] {
        const data = [];
        const wrapperData: ProtocolFindProductionLogsSummaryViewModelWrapper[] = [];

        dataWrapper.forEach ((dataRow, i) => {
            let alreadyAppended = true;
            let appendedSummaryDataRowWrapper = wrapperData.find(appendedDataWrapper => appendedDataWrapper.message === dataRow.message.substring(0, this.SUMMARY_MESSAGE_LENGTH));
            if (!appendedSummaryDataRowWrapper) {
                appendedSummaryDataRowWrapper = new ProtocolFindProductionLogsSummaryViewModelWrapper();
                alreadyAppended = false;
            }

            if (!appendedSummaryDataRowWrapper.productsArray.some(product => product === dataRow.product)) {
                appendedSummaryDataRowWrapper.productsArray.push(dataRow.product);
            }
            if (!appendedSummaryDataRowWrapper.applicationsArray.some(application => application === dataRow.application)) {
                appendedSummaryDataRowWrapper.applicationsArray.push(dataRow.application);
            }
            if (!appendedSummaryDataRowWrapper.timestampDatesArray.some(timestampDate => timestampDate === dataRow.timestampDate)) {
                appendedSummaryDataRowWrapper.timestampDatesArray.push(dataRow.timestampDate);
            }
            if (!appendedSummaryDataRowWrapper.userCodesArray.some(userCode => userCode === dataRow.userCode)) {
                appendedSummaryDataRowWrapper.userCodesArray.push(dataRow.userCode);
            }
            if (!appendedSummaryDataRowWrapper.emailsArray.some(email => email === dataRow.email)) {
                appendedSummaryDataRowWrapper.emailsArray.push(dataRow.email);
            }
            if (!appendedSummaryDataRowWrapper.deviceModelsArray.some(deviceModel => deviceModel === dataRow.deviceModel)) {
                appendedSummaryDataRowWrapper.deviceModelsArray.push(dataRow.deviceModel);
            }
            if (!appendedSummaryDataRowWrapper.productVersionsArray.some(productVersion => productVersion === dataRow.productVersion)) {
                appendedSummaryDataRowWrapper.productVersionsArray.push(dataRow.productVersion);
            }
            if (!appendedSummaryDataRowWrapper.applicationVersionsArray.some(applicationVersion => applicationVersion === dataRow.applicationVersion)) {
                appendedSummaryDataRowWrapper.applicationVersionsArray.push(dataRow.applicationVersion);
            }
            appendedSummaryDataRowWrapper.message = dataRow.message.substring(0, this.SUMMARY_MESSAGE_LENGTH);
            appendedSummaryDataRowWrapper.hits += 1;

            if (!alreadyAppended) {
                wrapperData.push(appendedSummaryDataRowWrapper);
            }

        });

        wrapperData.forEach((wrapper, i) => {
            const convertedData = new ProtocolFindProductionLogsSummaryViewModel();
            convertedData.position = i + 1;
            convertedData.products = wrapper.productsArray.join(';');
            convertedData.applications = wrapper.applicationsArray.join(';');
            convertedData.timestampTimeRange = wrapper.timestampDatesArray.join(';');
            convertedData.userCodes = wrapper.userCodesArray.join(';');
            convertedData.emails = wrapper.emailsArray.join(';');
            convertedData.deviceModels = wrapper.deviceModelsArray.join(';');
            convertedData.productVersions = wrapper.productVersionsArray.join(';');
            convertedData.applicationVersions = wrapper.applicationVersionsArray.join(';');
            convertedData.hits = wrapper.hits;
            convertedData.message = wrapper.message;

            data.push(convertedData);
        });

        return data;
    }
}

class ProtocolFindProductionLogsSummaryViewModelWrapper {
    productsArray: string[];
    applicationsArray: string[];
    timestampDatesArray: number[];
    message: string;
    userCodesArray: string[];
    emailsArray: string[];
    deviceModelsArray: string[];
    productVersionsArray: string[];
    applicationVersionsArray: string[];
    hits: number;

    constructor() {
        this.productsArray = [];
        this.applicationsArray = [];
        this.timestampDatesArray = [];
        this.message = '';
        this.userCodesArray = [];
        this.emailsArray = [];
        this.deviceModelsArray = [];
        this.productVersionsArray = [];
        this.applicationVersionsArray = [];
        this.hits = 0;
    }
}
